import { useState } from "react";
import { useLocation } from "react-router-dom";
import { format } from "date-fns";

import Header from "../../components/Header/Header";
import Navbar from "../../components/Navbar/Navbar";
import "./list.scss";
import { DateRange } from "react-date-range";
import { SearchItem } from "../../components/SearchItem/SearchItem";

export const List = () => {
   const location = useLocation();

   const [destination, setDestination] = useState(location.state.destination);
   const [date, setDate] = useState(location.state.date);
   const [openDate, setOpenDate] = useState(false);
   const [options, setOptions] = useState(location.state.options);

   return (
      <div>
         <Navbar />
         <Header type="list" />
         <div className="listContainer">
            <div className="listWrapper">
               <div className="listSearch">
                  <h1 className="lsTitle">Search</h1>

                  <div className="lsItem">
                     <label htmlFor="">Destination</label>
                     <input placeholder={destination} type="text" />
                  </div>

                  <div className="lsItem">
                     <label htmlFor="">Check-in Date</label>
                     <span onClick={() => setOpenDate(!openDate)}>
                        {`${format(
                           date[0].startDate,
                           "MM/dd/yyyy"
                        )} to ${format(date[0].startDate, "MM/dd/yyyy")} `}
                     </span>
                     {openDate && (
                        <DateRange
                           onChange={(item) => setDate([item.selection])}
                           minDate={new Date()}
                           ranges={date}
                        />
                     )}
                  </div>
                  <div className="lsItem">
                     <label>Options</label>

                     <div className="lsOptions">
                        <div className="lsOptionItem">
                           <span className="lsOptionText">
                              Min Price <small>per night</small>
                           </span>
                           <input type="number" className="lsOptionInput" />
                        </div>

                        <div className="lsOptionItem">
                           <span className="lsOptionText">
                              Max Price <small>per night</small>
                           </span>
                           <input type="number" className="lsOptionInput" />
                        </div>

                        <div className="lsOptionItem">
                           <span className="lsOptionText">Adult</span>
                           <input
                              type="number"
                              min={1}
                              className="lsOptionInput"
                              placeholder={options.adult}
                           />
                        </div>

                        <div className="lsOptionItem">
                           <span className="lsOptionText">Children</span>
                           <input
                              type="number"
                              min={0}
                              className="lsOptionInput"
                              placeholder={options.children}
                           />
                        </div>

                        <div className="lsOptionItem">
                           <span className="lsOptionText">Rooms</span>
                           <input
                              type="number"
                              min={1}
                              className="lsOptionInput"
                              placeholder={options.room}
                           />
                        </div>
                     </div>
                  </div>
                  <button className="btn">Search</button>
               </div>
               <div className="listResult">
                  <SearchItem />
                  <SearchItem />
                  <SearchItem />
                  <SearchItem />
                  <SearchItem />
                  <SearchItem />
                  <SearchItem />
                  <SearchItem />
                  <SearchItem />
               </div>
            </div>
         </div>
      </div>
   );
};

export default List;
